import React from "react";
import FlowDisplay from "./FlowDisplayer.js";
export default function ListComponent(props) {
    const { component, componentsList, form, onChange } = props;
    const childComponents = component.componentIds.map((id) => componentsList[id]);
    return (React.createElement("div", { id: component.id, className: props.isOutlined ? "flow-component-outlined" : "" },
        React.createElement(FlowDisplay, { outlinedComponent: "", components: childComponents, componentsList: componentsList, inputState: form, onChange: onChange })));
}
